import { createSelector } from 'reselect'

const getPopup = (state, popup) => state.popup[popup] || {}

export const popupVisible = createSelector([getPopup], popup => !!popup.visible)
